import { useParams } from "react-router-dom";
import DefaultLayout from "@/layouts/default";
import EditMeetsComp from "@/components/meets/edit-meets-comp";

const EditMeetingPage = () => {
const { short_code } = useParams()
return (<>
<DefaultLayout>
    <EditMeetsComp short_code={short_code}/>
</DefaultLayout>
</>)
}

export default EditMeetingPage